import {
  DummyControlSource,
  DummyControlSourceArgs,
} from "./DummyControlSource";
import {
  ROSLibJSControlSource as ROSLibJSControlSource,
  ROSLibJSControlSourceArgs,
} from "./ROSLibJS";
import {
  WebROSProxyControlSource,
  WebROSProxyControlSourceArgs,
} from "./WebROSProxy";
import {
  FoxgloveControlSource,
  FoxgloveControlSourceArgs,
} from "./Foxglove";

export const ControlSource = {
  WEBROSPROXY: {
    name: "WEBROSPROXY",
    port: 3000,
  },
  ROSLIBJS: {
    name: "ROSLIBJS",
    port: 9090,
  },
  FOXGLOVE: {
    name: "FOXGLOVE",
    // foxglove_bridge is deployed on 9090 (reusing rosbridge's port; the two are
    // never run at the same time), not Foxglove's usual 8765.
    port: 9090,
  },
  DUMMY: {
    name: "DUMMY",
    port: 666,
  },
} as const;

type MakeControlSourceFn = {
  (
    type: "WEBROSPROXY",
    ...args: WebROSProxyControlSourceArgs
  ): WebROSProxyControlSource;
  (type: "ROSLIBJS", ...args: ROSLibJSControlSourceArgs): ROSLibJSControlSource;
  (type: "FOXGLOVE", ...args: FoxgloveControlSourceArgs): FoxgloveControlSource;
  (type: "DUMMY", ...args: DummyControlSourceArgs): DummyControlSource;
};

export const makeControlSource: MakeControlSourceFn = (type, ...args): any => {
  switch (type) {
    case "WEBROSPROXY":
      return new WebROSProxyControlSource(
        ...(args as WebROSProxyControlSourceArgs)
      );
    case "ROSLIBJS":
      return new ROSLibJSControlSource(...(args as ROSLibJSControlSourceArgs));
    case "FOXGLOVE":
      return new FoxgloveControlSource(...(args as FoxgloveControlSourceArgs));
    case "DUMMY":
      return new DummyControlSource(...(args as DummyControlSourceArgs));
  }
};
